<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Партнеры</strong>
                </CCardHeader>

                <CCardBody>
                    <div class="table__preloader" v-if="loading && items">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <!-- <CCard class="p-4 mt-2">
                            <CRow class="mb-1 ml-1 d-flex align-items-center justify-content-between">
                                <CCol class="h4 mb-0 p-0">Агентский отчет</CCol>
                                <CCol class="d-flex align-items-center justify-content-end">
                                    <CSwitch
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="showFilters"
                                        class="ml-2" />
                                    <span class="ml-2">Настройки/Экспорт</span>
                                </CCol>
                            </CRow>
                            <CRow v-if="showFilters" class="ml-1 mb-1 align-items-center">
                                <CCol>
                                    <CRow class="mt-2">
                                        <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                            <span class="mr-1">Показать оплату</span>
                                        </CCol>
                                        <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                            <CSwitch
                                                color="dark"
                                                shape="pill"
                                                variant="opposite"
                                                :checked.sync="showDifference"
                                            />
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-2">
                                        <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                            <span class="mr-1">Дата начала</span>
                                        </CCol>
                                        <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                            <DatePicker
                                                v-model="datepicker.dateFrom"
                                                :language="datepicker.lang"
                                                :format="datepicker.format"
                                                input-class="custom-datepicker"
                                                placeholder="Выберите дату..."
                                            />
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-2">
                                        <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                            <span class="mr-1">Дата окончания</span>
                                        </CCol>
                                        <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                            <DatePicker
                                                v-model="datepicker.dateTo"
                                                :language="datepicker.lang"
                                                :format="datepicker.format"
                                                input-class="custom-datepicker"
                                                placeholder="Выберите дату..."
                                            />
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-2">
                                        <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                            <span class="mr-1">Фильтровать по</span>
                                        </CCol>
                                        <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                            <CSelect
                                                :horizontal="true"
                                                class="w-full"
                                                input-class="form-control custom-datepicker mb-0"
                                                :value.sync="exportFilter"
                                                :options="exportFilterOptions"
                                            />
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-2">
                                        <CCol cols="12" md="4" class="mt-1 d-flex align-items-center">
                                            <span class="mr-1">Включить Отмененные/Инциденты</span>
                                        </CCol>
                                        <CCol cols="12" md="8" class="mt-1 d-flex align-items-center">
                                            <CSwitch
                                                color="dark"
                                                shape="pill"
                                                variant="opposite"
                                                :checked.sync="exportCanceled"
                                            />
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-2">
                                        <CCol
                                            cols="12"
                                            class="mt-2 flex">
                                            <CButton color="primary" :disabled="processStarted" @click="doExport">Экспорт</CButton>
                                            <CButton color="primary" class="ml-2" :disabled="processStarted" @click="doSendExport">Экспортировать и отправить всем получателям</CButton>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="processStarted" class="mt-2">
                                        <CCol cols="12" class="mt-2 flex">
                                            Процесс экспорта запущен. &nbsp;<CLink to="/export">Перейти на страницу экспорта.</CLink>
                                        </CCol>
                                    </CRow>
                                </CCol>
                            </CRow>
                        </CCard> -->
                        <CDataTable
                            hover
                            striped
                            sorter
                            column-filter
                            :items="items"
                            :fields="fields"
                            :items-per-page="30"
                            :active-page="activePage"
                            :pagination="{ doubleArrows: true, align: 'center'}"
                            @page-change="pageChange"
                        >
                            <template #checkbox="data">
                                <td>
                                    <input v-model="selectedPartners" :value="data.item.id" type="checkbox" multiple />
                                </td>
                            </template>
                            <template #id="data">
                                <td>
                                    #{{ data.item.id }}
                                </td>
                            </template>
                            <template #title="data">
                                <td>
                                    <CLink :to="`/vip-partners/${data.item.id}`">{{ data.item.title }}</CLink>
                                </td>
                            </template>
                            <template #enabled="data">
                                <td>
                                    <CBadge
                                        :color="getBadge(data.item.enabled)"
                                    >&nbsp;{{ data.item.enabled ? 'Да' : 'Нет' }}&nbsp;</CBadge>
                                </td>
                            </template>
                        </CDataTable>
                    </template>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="$router.push('/vip-partners/create')">Создать</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import DatePicker from 'vuejs-datepicker';
    import moment from 'moment';
    import { ru } from 'vuejs-datepicker/dist/locale';
    import { ORDER_STATUS } from '../../utils/order';

    export default {
        name: 'Partners',

        components: {
            DatePicker,
        },

        data() {
            return {
                loading: true,
                items: [],
                selectedPartners: [],
                showFilters: false,
                processStarted: false,
                showDifference: false,
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    dateFrom: null,
                    dateTo: null,
                },
                exportMessage: '',
                exportFile: '',
                exportFilter: ORDER_STATUS.DONE,
                exportFilterOptions: [
                    { value: ORDER_STATUS.DONE, label: 'По дате завершения' },
                    { value: ORDER_STATUS.PAID, label: 'По дате оплаты' },
                ],
                exportCanceled: false,
                fields: [
                    { key: 'checkbox', label: '', _classes: '' },
                    { key: 'id', label: 'ID', _classes: 'font-weight-bold' },
                    { key: 'title', label: 'Название' },
                    { key: 'enabled', label: 'Активен' },
                ],
                activePage: 1,
            };
        },

        watch: {
            $route: {
                immediate: true,
                handler(route) {
                    if (route.query && route.query.page) {
                        this.activePage = Number(route.query.page);
                    }
                },
            },
        },

        async mounted() {
            this.loading = true;
            await Vue.axios
                .get('/vip-partners')
                .then(resp => {
                    this.items = resp.data;
                    this.loading = false;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
            pageChange(val) {
                this.$router.push({ query: { page: val } });
            },
            doExport({ sendToEmail = false }) {
                if (!this.selectedPartners.length) {
                    this.$root.$emit('showError', 'Выберите партнеров, для которых неободимо запустить импорт');
                    return;
                }
                if (!this.datepicker.dateFrom || !this.datepicker.dateTo) {
                    this.$root.$emit('showError', 'Укажите даты начала и окончания для экспорта');
                    return;
                }
                const filters = {
                    status: this.exportFilter,
                    canceled: this.exportCanceled
                }
                const dateFrom = moment(Date.parse(this.datepicker.dateFrom)).format('YYYY-MM-DD');
                const dateTo = moment(Date.parse(this.datepicker.dateTo)).format('YYYY-MM-DD');
                this.axios.get(
                    `/export/vip-partners/list?selectedPartners=${this.selectedPartners.join(',')}&dateFrom=${dateFrom}&dateTo=${dateTo}&filter=${JSON.stringify(filters)}&difference=${this.showDifference}&sendToEmail=${sendToEmail}`
                );
                this.processStarted = true;
            },
            doSendExport() {
                this.doExport({ sendToEmail: true });
            }
        },
    };
</script>
